import { useEffect, useRef, useState } from "react";

const images = [
"https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/bce1ef514_663569113_2485708945278814_971765740434788328_n.jpg",
"https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/437efb9c3_Chamo5.jpg",
"https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/150826ad6_665235863_1479451350191126_1575669123621564934_n.jpg",
"https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/a1800e089_Grohe.png",
"https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/f992cc685_Dusj_Termofuru.jpg",
"https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/082e674c1_SAUNAVEIBER_4.webp",
"https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/416272144_HIRO_3.jpg",
"https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/db758df8d_Abachi3.jpg",
"https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/68e1338eb_HYTTE_BADSTUE_GRNNTAK.jpg",
"https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/e21dbab05_Sauna.png",
"https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/45b848daf_fa40d6c3-3621-417c-87a2-1ece81a945a9.jpg",
"https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/754f1f53a_Stone_Floor.jpg",
"https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/46d960a4c_LykkeVervbier.jpg",
"https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/1f3d9cc3b_Mori-Gray3.png",
"https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/f8bcf6bf8_SAUNAVEIBER_6.webp",
"https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/0f7f8bf4a_Abachi4.jpg",
"https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/f179bf3aa_Dolomiti_black_1.jpg",
"https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/6c57d7a04_Huum.jpg",
"https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/5415c76fb_ThermoAlder.jpg"
];


export default function GallerySection() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {if (entry.isIntersecting) setVisible(true);},
      { threshold: 0.05 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="galleri" ref={ref} className="py-24 md:py-40 bg-secondary/50">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p className="text-primary mb-6 text-sm font-body uppercase tracking-widest-2xl">GALLERI

          </p>
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-light italic">
            Våre prosjekter
          </h2>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4">
          {images.map((src, i) =>
          <div
            key={i}
            className={`break-inside-avoid overflow-hidden group transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`
            }
            style={{ transitionDelay: `${i * 80}ms` }}>
            
              <img
              src={src}
              alt={`LYKKE NOMAD projekt ${i + 1}`}
              className="w-full object-cover group-hover:scale-105 transition-transform duration-[1.5s]"
              loading="lazy" />
            
            </div>
          )}
        </div>
      </div>
    </section>);

}